<template>
  <section id="product-list">
    <div class="no-files-warning" v-if="selectedFiles.length === 0">
      <span v-if="filesInList > 0">
        Selecteer een bestand om door te gaan
      </span>
      <span v-else>
        Upload een bestand om door te gaan
      </span>
    </div>
    <header>
      <h1 v-if="secure">Secured printen</h1>
      <h1 v-else>Printen</h1>

      <div
        class="spec-button-container"
        v-if="
          productOrderStore.userPrintTemplates.length > 0 && !hideTemplatesMenu
        "
      >
        <spec-button
          :title="'Meer'"
          :selected="templateSelected"
          @action="showUserTemplates = !showUserTemplates"
          :inactive="false"
          :has-sub="true"
        >
        </spec-button>
        <templates-menu
          v-if="showUserTemplates"
          :selected-files="selectedFiles"
          @close="showUserTemplates = false"
          @select-template="setUserTemplate"
        />
      </div>
    </header>
    <main>
      <ul>
        <product
          v-for="product in filteredProducts"
          :key="product.title"
          :product="product"
          :active="selectedProductTitle === product.title"
          :selectable="selectedFiles.length"
          :disabled="!!productDisabledReason(product, liveSelectedFiles)"
          :disabled-reason="productDisabledReason(product, liveSelectedFiles)"
          @click="selectProduct(product)"
        ></product>
      </ul>
    </main>
  </section>
</template>

<script>
import Product from './productList/Product.vue'
import SpecButton from '@/components/ui/SpecButton.vue'
import TemplatesMenu from './TemplatesMenu.vue'
import ProductOrderMixin from '@/features/productOrder/ProductOrderMixin'
import { useProductOrderStore } from '@/features/productOrder/ProductOrder.store'
import { useFileListStore } from '@/stores/FileList.store'
import { mapStores } from 'pinia'

export default {
  props: ['selectedFiles', 'selectedProductTitle', 'filesInList', 'secure'],
  mixins: [ProductOrderMixin],
  components: { Product, SpecButton, TemplatesMenu },
  data() {
    return {
      showUserTemplates: false
    }
  },
  computed: {
    ...mapStores(useProductOrderStore, useFileListStore),
    selectedProduct() {
      if (
        this.selectedFiles.length === 1 &&
        this.selectedFiles[0].productSpecs.title
      ) {
        return this.selectedFiles[0].productSpecs.title
      } else {
        return ''
      }
    },
    filteredProducts() {
      if (this.productOrderStore.propositonProducts.length) {
        return this.productOrderStore.propositonProducts
      } else if (this.secure) {
        return this.productOrderStore.productsSecured
      } else {
        const userLevel = this.rootStore.user.securityLevel
        return this.productOrderStore.products.filter((prod) => {
          const prodLevel = prod.securityLevel ? prod.securityLevel : 0
          return userLevel >= prodLevel
        })
      }
    },
    templateSelected() {
      return this.selectedFiles.some(
        (file) => file.productSpecs.userTemplate === true
      )
    },
    hideTemplatesMenu() {
      return this.rootStore.theme.customFields.printOrder?.hideUserTemplates
    },
    // Read the selected files from the store, so mimeType and status stay reactive
    // while a file is still being processed
    liveSelectedFiles() {
      return this.selectedFiles.map(
        (file) =>
          this.fileListStore.fileList.find(
            (f) => f.fileName === file.fileName
          ) || file
      )
    }
  },
  methods: {
    selectProduct(product) {
      if (!this.selectedFiles.length) {
        return
      }

      // Prevent selecting a product that is unsuitable for the file type, or
      // that would mix secured and regular products in one order
      if (this.productDisabledReason(product, this.liveSelectedFiles)) {
        return
      }
      // Prevent selecting product if any selected file is analyzing
      // Check status from the store to ensure we have the latest status
      const hasAnalyzingFiles = this.selectedFiles.some((file) => {
        const storeFile = this.fileListStore.fileList.find(
          (f) => f.fileName === file.fileName
        )
        return storeFile && storeFile.status === 'ANALYZING'
      })

      if (hasAnalyzingFiles) {
        return
      }
      this.$emit('select-product', product)
    },
    setUserTemplate(template) {
      this.showUserTemplates = false
      this.$emit('select-user-template', template)
    }
  }
}
</script>

<style lang="scss" scoped>
header {
  padding: 0 25px 0 30px;
  height: 19px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

h1 {
  font-size: 15px;

  font-weight: 600;
  font-size: 0.875rem;
  color: var(--text-color);
  margin: 0;
}

#product-list {
  position: relative;
  padding-top: 25px;
}

.spec-button-container {
  position: relative;
}

ul {
  display: flex;
  flex-wrap: wrap;
  padding: 5px 13px 15px;
}

.no-files-warning {
  position: absolute;
  padding: 25px;
  background: rgba(255, 255, 255, 0.9);
  width: 100%;
  height: calc(100% - 25px);
  border-radius: 40px;
  text-align: center;
  font-weight: 600;
  padding-top: 102px;
  z-index: 1;
}
</style>
